import React from 'react';
import { PredictionCard } from './PredictionCard';
interface PredictionOption {
  id: number;
  text: string;
  probability: number;
  price: number;
}
interface Prediction {
  id: number;
  question: string;
  description: string;
  category: string;
  endDate: string;
  totalVolume: string;
  options: PredictionOption[];
  imageUrl: string;
}
interface FeaturedPredictionProps {
  prediction: Prediction;
}
export const FeaturedPrediction = ({
  prediction
}: FeaturedPredictionProps) => {
  return <div className="mb-10" data-id="element-195">
      <h2 className="text-2xl font-bold mb-4" data-id="element-196">Featured Prediction</h2>
      <PredictionCard id={prediction.id} question={prediction.question} description={prediction.description} category={prediction.category} endDate={prediction.endDate} totalVolume={prediction.totalVolume} options={prediction.options} imageUrl={prediction.imageUrl} isLarge={true} data-id="element-197" />
    </div>;
};